module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vCOppS/tc-custom/9781788852098.jpg?1712387828503",
      "alt": "This image is the cover for the book Deeside Way, Long Distance Guides"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Deeside Way, Long Distance Guides\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“The first guide to one of Scotland’s long-distance trails” from an experienced hillwalker and former editor of "), _c('i', [_vm._v("The Great Outdoors")]), _vm._v(" magazine ("), _c('i', [_vm._v("The Northern Times")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The Deeside Way is a long-distance path running for 66km (41 miles) from Aberdeen, the oil capital of Europe, to Ballater in Royal Deeside in the Cairngorms National Park. Mainly following the course of old Royal Deeside Railway line, it is suitable for cyclists as well as walkers. There is much to be seen along the Way of scenic beauty, historical interest, and thriving wildlife. There are fascinating links to the Romans, to Queen Victoria and Balmoral, and even to bodysnatchers!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This new Guide covers all of these, with a wealth of practical information on preparation for the walk, accommodation, transport, and much else. As well as describing the Way itself, Peter Evans includes six additional walks in and around Deeside, varying from short low-level walks to mountain summits. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Peter Evans\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Birlinn\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0